import React from 'react';
import { EMENDA_TYPES, EMENDA_LABELS } from '../../../utils/emendas/constants';
import './EmendaTabs.css';

/**
 * Componente de Tabs para alternar entre Emendas Municipais e Estaduais
 * @param {string} activeTab - Tab ativa (EMENDA_TYPES.MUNICIPAL ou EMENDA_TYPES.ESTADUAL)
 * @param {function} onTabChange - Callback quando tab é alterada
 */
export default function EmendaTabs({ activeTab, onTabChange }) {
  return (
    <div className="emenda-tabs">
      <div className="emenda-tabs__container">
        <button
          className={`emenda-tabs__tab ${activeTab === EMENDA_TYPES.MUNICIPAL ? 'emenda-tabs__tab--active' : ''}`}
          onClick={() => onTabChange(EMENDA_TYPES.MUNICIPAL)}
          type="button"
        >
          <span className="emenda-tabs__icon">🏛️</span>
          <span className="emenda-tabs__label">{EMENDA_LABELS[EMENDA_TYPES.MUNICIPAL]}</span>
        </button>

        <button
          className={`emenda-tabs__tab ${activeTab === EMENDA_TYPES.ESTADUAL ? 'emenda-tabs__tab--active' : ''}`}
          onClick={() => onTabChange(EMENDA_TYPES.ESTADUAL)}
          type="button"
        >
          <span className="emenda-tabs__icon">🏢</span>
          <span className="emenda-tabs__label">{EMENDA_LABELS[EMENDA_TYPES.ESTADUAL]}</span>
        </button>
      </div>

      <div className="emenda-tabs__indicator" data-active={activeTab} />
    </div>
  );
}
